import { Fragment, useEffect, useState } from "react";
import Colors from "./app/assets/styles";
import { createTheme, ThemeProvider } from "@mui/material";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "./app/layout/dashboard";
import PublicRoutes from "./app/routes/public";
import AdminRoutes from "./app/routes/admin";
import "@fontsource/noto-sans";
import Login from "./app/views/admin/Login/index";
import useAuth from "./app/hooks/useAuth";
import { ToasterContainer } from "./app/components/Toaster";
import AuthServices from "./app/api/VoucherServices";
import VendorLogin from "./app/views/admin/VendorForm/VendorLogin";
import VendorRoutes from "./app/routes/vendor";
import LoaderRegistration from "./app/views/admin/LoaderRegisteration";

const theme = createTheme({
  typography: {
    fontFamily: "Noto Sans, sans-serif",
    h1: { fontSize: "72px" },
    h2: { fontSize: "60px" },
    h3: { fontSize: "48px" },
    h4: { fontSize: "36px" },
    h5: { fontSize: "24px" },
    h6: { fontSize: "18px" },
    subtitle1: { fontSize: "16px" },
    subtitle2: { fontSize: "14px", fontWeight: 400 },
    caption: { fontSize: "12px" },
  },
  palette: {
    primary: {
      main: Colors.primary,
    },
  },
});

function App() {
  const { user } = useAuth();

  const [isVendor, setIsVendor] = useState(user?.role == 'vendor' ? true : false);
  const [step, setStep] = useState(0);

  
  useEffect(() => {
    if (user) {
      setIsVendor(user?.role == 'vendor' ? true : false)
    }

  }, [user])


  const getVendorDetail = async () => {
    try {
      const { data } = await AuthServices.getVendorDetail();
      console.log(data);
      setStep(data?.vendor?.active_step);
    } catch (error) {
      console.error("❌ API Error:", error);
    }
  };

  useEffect(() => {
    getVendorDetail();
  }, []);

  return (
    <Fragment>
      <ThemeProvider theme={theme}>
        <ToasterContainer />
        <BrowserRouter>
          <Routes>
            {/* 🔑 Public Routes */}
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/vendor-login" element={<VendorLogin />} />
            <Route path="/continue-registration" element={<LoaderRegistration />} />


            {/* 🔑 Protected Routes */}
            {user ? (
              isVendor ? (
                // ✅ Vendor Routes
                VendorRoutes.map((item, i) => (
                  <Route key={i} path={item.path} element={item.component} />
                ))
              ) : (
                // ✅ Admin Dashboard Routes
                <Route element={<DashboardLayout />}>
                  {AdminRoutes.map((item, i) => (
                    <Route key={i} path={item.path} element={item.component} />
                  ))}
                </Route>
              )
            ) : (
              // 🚀 Redirect to login if no user
              <Route path="*" element={<Navigate to={isVendor ? "/vendor-login" : "/login"} replace />} />
            )}

          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </Fragment>
  );
}

export default App;
